import {
  IntegrationManagedAgentsPage,
  IntegrationManagedAgentsPageProps,
} from "~/pages/integrations/IntegrationManagedAgentsPage/IntegrationManagedAgentsPage";

const IntegrationManagedAgentsEntryPage = ({
  scope,
}: IntegrationManagedAgentsPageProps) => {
  return <IntegrationManagedAgentsPage scope={scope} />;
};

export default IntegrationManagedAgentsEntryPage;
